<script lang="ts" setup>
import checkCircleIcon from '@/assets/img/icon/check-circle-outline.png';
import circleIcon from '@/assets/img/icon/circle-outline.png';
import { AppTypography } from '@/core/components';

const props = withDefaults(
  defineProps<{
    password?: string;
  }>(),
  {
    password: '',
  }
);

const hasEightCharacters = computed(() => props.password.length >= 8);
const hasOneUppercase = computed(() => /[A-Z]/.test(props.password));
const hasNumber = computed(() => /\d/.test(props.password));
</script>
<template>
  <v-sheet
    v-if="password"
    class="password-criteria d-flex flex-column"
    :class="{
      'password-criteria--eight-chars': hasEightCharacters,
      'password-criteria--one-uppercase': hasOneUppercase,
      'password-criteria--one-number': hasNumber,
    }"
  >
    <div
      class="d-flex pa-o"
      :class="{
        'password-checked': hasEightCharacters,
      }"
      data-testid="eigth-characters"
    >
      <img :src="hasEightCharacters ? checkCircleIcon : circleIcon" width="28px" height="28px" />
      <AppTypography type="footnote-1" class="font-footnote ml-1 pa-1"> at least 8 characters </AppTypography>
    </div>
    <div
      class="d-flex pa-o mt-1"
      :class="{
        'password-checked': hasOneUppercase,
      }"
      data-testid="one-uppercase"
    >
      <img :src="hasOneUppercase ? checkCircleIcon : circleIcon" width="28px" height="28px" />
      <AppTypography type="footnote-1" class="font-footnote ml-1 pa-1"> at least 1 uppercase letter </AppTypography>
    </div>
    <div
      class="d-flex pa-o mt-1"
      :class="{
        'password-checked': hasNumber,
      }"
      data-testid="one-number"
    >
      <img :src="hasNumber ? checkCircleIcon : circleIcon" width="28px" height="28px" />
      <AppTypography type="footnote-1" class="font-footnote ml-1 pa-1"> at least 1 number </AppTypography>
    </div>
  </v-sheet>
</template>
<style lang="scss" scoped>
.password-criteria {
  .password-checked {
    color: #05704e;
  }
}
</style>
